/**
 * Analytics configuration.
 * All values are read from VITE_* env vars and inlined at build time.
 * These are intentionally public (GA4 IDs and Hotjar URLs are not secrets).
 */
export const analyticsConfig = {
  ga4MeasurementId: import.meta.env.VITE_GA_MEASUREMENT_ID || '',
  hotjarScriptUrl: import.meta.env.VITE_HOTJAR_SCRIPT_URL || '',
  /** Log every tracked event to console in dev. */
  debug: import.meta.env.DEV,
  /** Delay (ms) before injecting scripts after consent — keeps initial render snappy. */
  loadDelayMs: 3500,
  /** Routes where tracking is suppressed entirely. */
  excludedPathPrefixes: [
    '/internal-dashboard-9351', // admin
    '/dashboard',                // organizer dashboard sub-pages
    '/embed',                    // iframe widget
    '/reset-password',
  ] as const,
} as const;

/** True when analytics has been correctly configured at build time. */
export const isAnalyticsConfigured = (): boolean =>
  Boolean(analyticsConfig.ga4MeasurementId) || Boolean(analyticsConfig.hotjarScriptUrl);

/** Pages where third-party tracking should be skipped (admin, embed, etc.). */
export const isTrackingExcludedPath = (pathname: string): boolean =>
  analyticsConfig.excludedPathPrefixes.some((p) => pathname.startsWith(p));
